import axiosInstance from "../../axiosInstance";

const BASE_URL = "/elearning/results";

export const getResults = async (params = {}) => {
  const res = await axiosInstance.get(BASE_URL, { params });
  return res.data;
};

export const getResultStats = async (params = {}) => {
  const res = await axiosInstance.get(`${BASE_URL}/stats`, { params });
  return res.data;
};

export const getResultById = async (id) => {
  const res = await axiosInstance.get(`${BASE_URL}/${id}`);
  return res.data;
};

export const updateResult = async (id, data) => {
  const res = await axiosInstance.patch(`${BASE_URL}/${id}`, data);
  return res.data;
};

/** @param {{ class_id: string|number, import_mode?: 'full'|'single', score_field?: string }} opts */
export const importResults = async (file, opts) => {
  const { class_id, import_mode = "full", score_field } =
    typeof opts === "object" && opts !== null && !Array.isArray(opts)
      ? opts
      : { class_id: opts };
  const formData = new FormData();
  formData.append("file", file);
  formData.append("class_id", String(class_id));
  formData.append("import_mode", import_mode);
  if (import_mode === "single" && score_field) {
    formData.append("score_field", score_field);
  }
  const res = await axiosInstance.post(`${BASE_URL}/import`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
    timeout: 60_000,
  });
  return res.data;
};

export const exportResultsCSV = async (params = {}) => {
  const res = await axiosInstance.get(`${BASE_URL}/export`, {
    params,
    responseType: "blob",
  });
  return res.data;
};

export const deleteResult = async (id) => {
  const res = await axiosInstance.delete(`${BASE_URL}/${id}`);
  return res.data;
};
